export default "__VITE_ASSET__C7d3b0ma__"